import { render } from "./PersonsByContractHoldPage.vue?vue&type=template&id=79d9af6a&scoped=true"
import script from "./PersonsByContractHoldPage.vue?vue&type=script&lang=js"
export * from "./PersonsByContractHoldPage.vue?vue&type=script&lang=js"

import "./PersonsByContractHoldPage.vue?vue&type=style&index=0&id=79d9af6a&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d9af6a"]])

export default __exports__